export const getS3BucketName = () => {
  const AWS_S3_PUBLIC_BUCKET = process.env.AWS_S3_PUBLIC_BUCKET as string;
  if (!AWS_S3_PUBLIC_BUCKET) {
    throw new Error('AWS_S3_PUBLIC_BUCKET is not set');
  }

  return AWS_S3_PUBLIC_BUCKET;
};
